import { AxiosResponse } from 'axios';
import { LumenResponse } from '../types/LumenResponse';

export const responseBody = (response: AxiosResponse) => {
  const lumenResponse: LumenResponse = response.data;
  return lumenResponse.data;
};
